<template>
  <div v-if="loading"  style="display: flex; justify-content: center; margin-top: 10%;">
  <h3>Lab Cases</h3>
  <Loader />
</div>
  <v-container fluid v-else-if="showLabcases" class="py-4 px-2">
    <!-- Lab Cases List -->
    <v-card class="mb-6 rounded-xl" elevation="3" v-if="showLabCasesList">
      <v-card-title class="d-flex align-center text-h6 font-weight-bold">
        <v-icon class="mr-2" color="blue-darken-2">mdi-flask-outline</v-icon>
        Lab Cases
      </v-card-title>
      <v-divider />
      <v-data-table
        :headers="headers"
        :items="labCasesData"
        item-value="lab_id"
        class="elevation-1 rounded-lg"
        density="comfortable"
        @click:row="(event, { item }) => selectLabCase(item)"
      >
        <template #item.status="{ item }">
          <v-chip
            :color="getStatusColor(item.status)"
            text-color="white"
            size="small"
            class="ma-1 font-weight-medium"
            pill
          >
            <v-icon start small>{{ getStatusIcon(item.status) }}</v-icon>
            {{ getStatusValue(item.status) }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>

    <!-- Selected Lab Case Detail -->
    <v-card v-if="showLabCaseDetail" class="pa-5 rounded-xl" elevation="3">
      <!-- Back Button -->
      <div class="d-flex align-center mb-4">
        <v-btn icon variant="text" size="small" @click="backtoLablist">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-card-title class="ml-2 text-h6 font-weight-bold">Lab Case Details</v-card-title>
      </div>

      <!-- Lab Info -->
      <v-row dense>
        <v-col cols="12">
          <div class="d-flex align-center mb-2">
            <v-icon color="blue-darken-2" class="mr-2">mdi-domain</v-icon>
            <strong>{{ selectedCase.Lab_Name || "—" }}</strong>

            <!-- Lab Phone (status = 2) -->
            <v-btn
              v-if="selectedCase.status === 2"
              icon
              variant="text"
              size="small"
              class="ml-2"
              @click.stop="phoneCall(selectedCase.Lab_Name, selectedCase.Lab_Phone)"
            >
              <v-tooltip location="bottom" :text="phoneFormat(selectedCase?.Lab_Phone)">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" size="small" color="green">mdi-phone-classic</v-icon>
                </template>
              </v-tooltip>
            </v-btn>
             <!-- Create Conversation -->
          <div>
          <v-btn
            icon
            variant="text"
            size="small"
            class="ml-2"
            @click="openlabmessage(selectedCase)"
          >
<v-tooltip location="bottom" :text="hasInternalConvo ? 'Open Conversation' : 'Create Conversation'">
  <template v-slot:activator="{ props }">
    <v-btn
      v-bind="props"
      icon
      variant="text"
      size="small"
      class="ml-2"
      @click="openlabmessage(selectedCase)"
    >
      <v-icon size="26px" :color="hasInternalConvo ? 'blue-darken-2' : 'grey-darken-2'">
        {{ hasInternalConvo ? 'mdi-chat-processing' : 'mdi-chat-plus-outline' }}
      </v-icon>
    </v-btn>
  </template>
</v-tooltip>

          </v-btn>
          </div>
          </div>
        </v-col>
      </v-row>

      <v-divider class="my-4" />

      <!-- Case Info -->
     <v-row dense>
  <v-col>
  {{ selectedCase.Provider }}
  <div
      v-if="selectedCase.DateTimeDue && selectedCase.DateTimeDue !== '0001-01-01T00:00:00'"
      class="text-body-1"
    >
      <strong>Date Due:</strong> {{ displayDate(selectedCase.DateTimeDue) }}
    </div>
  

    <v-icon size="small" :color="getStatusColor(selectedCase.status)">
      {{ getStatusIcon(selectedCase.status) }}
    </v-icon>
    <span class="ml-1">
      {{ displaylabdata(selectedCase.status, selectedCase) }}
    </span>
  
</v-col>


  <v-col cols="12">
    <p v-if="selectedCase.Instructions">
      <span class="detail-label">Instructions:</span>
      <span
        :class="((selectedCase?.Instructions || '').toLowerCase().includes('stage'))
          ? 'text-blue-darken-2 font-weight-bold'
          : 'text-grey-darken-3'"
      >
        {{ selectedCase?.Instructions }}
      </span>
    </p>
  </v-col>
</v-row>

        <!-- Edit Mode -->
        <div v-if="editMode" class="mt-4">
          <div class="mb-2 text-blue-darken-2 font-weight-medium">
            You are updating the Lab Case
          </div>

       <v-text-field  variant="plain" v-model="editCase.DateTimeDue" type="datetime-local" label="Date Due" :value="getValidDate(editCase.DateTimeDue)"/>
       <v-text-field variant="plain" v-model="editCase.DateTimeCreated" type="datetime-local" label="Date Created" :value="getValidDate(editCase.DateTimeCreated)"/>
       <v-text-field variant="plain" v-model="editCase.DateTimeSent" type="datetime-local" label="Date Sent" :value="getValidDate(editCase.DateTimeSent)"/>
       <v-text-field variant="plain" v-model="editCase.DateTimeRecd" type="datetime-local" label="Date Received" :value="getValidDate(editCase.DateTimeRecd)"/>
       <v-text-field variant="plain" v-model="editCase.DateTimeChecked" type="datetime-local" label="Date Checked" :value="getValidDate(editCase.DateTimeChecked)"/>

          <v-text-field variant="filled" v-model="editCase.InvoiceNum" label="Invoice Number" />
          <v-textarea variant="plain" v-model="editCase.Instructions" label="Instructions" />
        </div>

        <!-- Action Buttons -->
        <div class="d-flex justify-end mt-4">
<v-btn
  v-if="!editMode"
  color="primary"
  @click="startEditMode"
  class="edit-icon-btn"
  elevation="3"
  size="small"
  icon
>
  <v-icon size="22px" color="white">mdi-pencil</v-icon>
</v-btn>

          <v-btn v-else color="green" :loading="saving" @click="updateLabCase">
            <v-icon left>mdi-check</v-icon>Save
          </v-btn>

          <v-btn v-if="editMode" variant="text" color="red" @click="cancelEdit">
            Cancel
          </v-btn>
        </div>
      </v-card>
  </v-container>

  <!-- Not Open Dental Patient -->
  <div v-else class="d-flex justify-center align-center" style="min-height: 200px;">
    <p class="text-red-darken-4 bg-red-lighten-5 pa-4 rounded-lg text-center font-weight-medium">
      Contact is not an Open Dental patient.
    </p>
  </div>
</template>


<script>
import { mapGetters, mapMutations } from 'vuex/dist/vuex.cjs.js';
import { phoneFormat } from "../../../util/util";
import dayjsMixin from "../../../mixins/dayjsMixin";
import EventBus from "../../../eventBus";
import odService from '../../../services/odService';
import Loader from '../../UIComponents/Loader.vue';
import ALERT  from '../../../constants/alert'
export default {
  name: "LabCasesDetails",
  mixins: [dayjsMixin],
  props: {
    contact: { type: Object, default: null, required: true },
  },
  components: { Loader },
  data() {
    return {
      headers: [
        { title: "Lab Name", key: "Lab_Name" },
        { title: "Lab Phone", key: "Lab_Phone" },
        { title: "Status", key: "status" },
        { title: "Provider", key: "Provider" },
      ],
      labCasesData: [],
      selectedCase: null,
      showLabcases: false,
      showLabCasesList: true,
      showLabCaseDetail: false,
      loading:false,
      editCase: null,
      editMode: false,
      saving: false,
    };
  },
  computed: {
    ...mapGetters("frontdesk", ["odData"]),
    ...mapGetters("convos",["internal_convos"]),
  },
  watch: {
    contact: {
      immediate: true,
      handler(newContact) {
        this.editMode = false;
        if (newContact && newContact.contact_id) {
          this.ODlabdata(newContact);
        } else {
          this.showLabcases = false;
          this.labCasesData = [];
        }
      },
    },
  },
  methods: {
        ...mapMutations("frontdesk",["setLabCaseNum","updateLabStatus"]),

    startEditMode() {
      this.editCase = { ...this.selectedCase };
      this.editMode = true;
    },

    backtoLablist() {
      this.showLabCasesList = true;
      this.showLabCaseDetail = false;
      this.editMode = false;
    },

    cancelEdit() {
    this.editCase = null;
    this.editMode = false;
    },
async selectLabCase(labCase) {
  this.originalCase = { ...labCase };

  this.selectedCase = { ...labCase };


    try {
  const response  = await odService.checkLabConvoStatus(labCase.LabCaseNum);
    this.hasInternalConvo = !!response?.data?.hasConvo;
      this.showLabCasesList = false;
  this.showLabCaseDetail = true;
  this.editMode = false;
} catch (error) {
    console.error("Failed to check internal conversation:", error);
    this.hasInternalConvo = false;
  }
},

  calculateLabStatus({ DateTimeCreated, DateTimeSent, DateTimeRecd, AptDateTime }) {
    const isValidDate = (dt) => dt && dt !== "0001-01-01 00:00:00";
    if (isValidDate(DateTimeCreated) && !isValidDate(DateTimeSent) && !isValidDate(DateTimeRecd) && !isValidDate(AptDateTime)) { return 1;}
    if (isValidDate(DateTimeSent) && !isValidDate(DateTimeRecd) && !isValidDate(AptDateTime)) {return 2; }
    if (isValidDate(DateTimeRecd) && !isValidDate(AptDateTime)) { return 3; }
    if (isValidDate(AptDateTime)) {return 4;}
    return 0;
  },
   async updateLabCase() {
  this.saving = true;
  try {
    const changes = this.getChangedFields(this.originalCase, this.editCase);
    if (Object.keys(changes).length === 0) {
      this.editMode = false;
       this.editCase = null;
      return;
    }

    // LabCaseNum so API to update lab data
    const payload = { 
      LabCaseNum: this.selectedCase.LabCaseNum,
      ...changes,
    };

   const resdata = await odService.updateLabCase(payload);
if (resdata?.data) {
     const newStatus = this.calculateLabStatus(resdata.data.data);
     this.updateLabStatus({
         contactId: this.contact.contact_id,
         labNum: resdata.data.data.LaboratoryNum,
         newStatus
     });
    }
    const matchedCase = this.labCasesData.find(
  (item) => item.Lab_Num === resdata.data.data.LaboratoryNum
);

if (matchedCase) {
  Object.assign(matchedCase, this.editCase);
}

    this.selectedCase = { ...this.editCase };
    this.originalCase = { ...this.editCase }; 
    this.editMode = false;
    this.editCase = null;
    EventBus.$emit("alert", {
            message: resdata.data.message,
            type: ALERT.SUCCESS
          });
  } catch (err) {
    console.error("Update error:", err);
  } finally {
    this.saving = false;
  }
},

getChangedFields(original, updated) {
  const changes = {};
  for (const key in updated) {
    const origVal = original[key];
    const newVal = updated[key];
    
    // Handle simple compare
    if (JSON.stringify(origVal) !== JSON.stringify(newVal)) {
      changes[key] = newVal;
    }
  }
  return changes;
},

    openlabmessage(data){
      const matchedConvo = this.internal_convos.find((convo) => 
      convo.convo_references?.some((ref) => ref.LabCaseNum === data.LabCaseNum)
    );
  
    if(matchedConvo){
      EventBus.$emit("openlabconversation",matchedConvo);
      }else{ 
        this.setLabCaseNum(data.LabCaseNum);
           setTimeout(() => {
        EventBus.$emit("createConvo", null);
      }, 0);
    }
    },
       displayDate(date) {
      if (!date) return "—";

      // handle bad Open Dental defaults
      const invalids = ["1900-01-01", "1901-01-01", "0001-01-01"];
      if (invalids.some((d) => date.startsWith(d))) return "—";
      return this.simpleDateFormat(date);
    },
      getValidDate(date) {
    // Handle invalid Open Dental dates
    const invalidDates = ['0001-01-01T00:00:00', '1900-01-01T00:00:00', '1901-01-01T00:00:00'];
    return invalidDates.includes(date) ? '' : date;
  },
    displaylabdata(status, data) {
      if (status === 1) return this.displayDate(data.Date_Created);
      if (status === 2) return this.displayDate(data.DateTimeSent);
      if (status === 3) return this.displayDate(data.DateTimeRecd);
      if (status === 4) return this.displayDate(data.Apt_Date_Time);
    },

    phoneCall(name, number) {
      console.log("this call to the lab num and name ", name, number);
      EventBus.$emit("call-event", { name, number });
    },
   getStatusColor(status) {
  switch (String(status)) {
    case "1": return "orange darken-2";   
    case "2": return "blue darken-2";    
    case "3": return "green darken-2";    
    case "4": return "teal darken-2";    
    default:  return "grey lighten-1";    
  }
},

getStatusIcon(status) {
  switch (String(status)) {
    case "1": return "mdi-clipboard-text-off-outline";          
    case "2": return "mdi-truck-delivery-outline";
    case "3": return "mdi-email-arrow-left-outline";  
    case "4": return "mdi-calendar-range";           
    default:  return "mdi-help-circle-outline";   
  }
},

    getStatusValue(status) {
      switch (String(status)) {
          case "1": return "Created";
          case "2": return "Sent";
          case "3": return "Received";
          case "4": return "Appointment Scheduled";
        default: return "Status Unknown";
      }
    },

    phoneFormat,
 async ODlabdata(contact) {
  const matched = this.odData.find((item) => item.contact_id === contact.contact_id);
  if (!matched) {
    console.warn("No matched record found for contact_id:", contact.contact_id);
    this.labCasesData = [];
    this.showLabcases = false;
    return;
  }

      this.loading = true;
      try {
        const data = { filter: { PatNum: matched.od_json[0].PatNum } };
        const contactlabdata = await odService.getlabcases(data);
        const patnumlabdetails = contactlabdata.data.data[0].od_json;

        if (Array.isArray(patnumlabdetails) && patnumlabdetails.length > 1) {
          this.labCasesData = patnumlabdetails;
          this.showLabcases = true;
          this.showLabCasesList = true;
          this.showLabCaseDetail = false;
        } else if (Array.isArray(patnumlabdetails) && patnumlabdetails.length === 1) {
          this.labCasesData = patnumlabdetails;
          await this.selectLabCase(this.labCasesData[0]);
          this.showLabcases = true;
          this.showLabCasesList = false;
          this.showLabCaseDetail = true;
        } else {
          this.labCasesData = [];
          this.showLabcases = false;
        }
      } catch (error) {
        console.error("Error fetching lab cases:", error);
      } finally {
        this.loading = false; 
      }
    }
  },
};
</script>
<style scoped>
.lab-detail p {
  margin: 8px 0;
}

.detail-label {
  font-weight: 600;
  min-width: 110px;
  display: inline-block;
  color: #444;
}

.status-chip .v-chip__content {
  display: flex;
  align-items: center;
  gap: 6px;
}

.v-card {
  border-radius: 14px !important;
}

.v-data-table {
  border-radius: 10px;
  overflow: hidden;
}
.edit-icon-btn {
  background-color: #1976d2; 
  border-radius: 50%; 
  width: 40px;
  height: 40px;
  transition: 0.3s ease;
  box-shadow: 0 2px 6px rgba(25, 118, 210, 0.4);
}

.edit-icon-btn:hover {
  background-color: #0451aa;
  box-shadow: 0 4px 10px rgba(0, 103, 206, 0.6);
}
.v-btn:hover .v-icon {
  transform: scale(1.15);
  transition: transform 0.2s ease;
}
</style>